type AnalyticsValue = string | number | boolean;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, AnalyticsValue>>;
  }
}

export const trackEvent = (
  event: string,
  parameters: Record<string, AnalyticsValue> = {},
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...parameters });
};

export const openCalendly = (location: string) => {
  trackEvent("booking_click", {
    booking_provider: "calendly",
    link_url: "https://calendly.com/agwipol/meet-with-me",
    link_location: location,
  });
  window.open(
    "https://calendly.com/agwipol/meet-with-me",
    "_blank",
    "noreferrer",
  );
};

export const trackWebVital = (metric: {
  id: string;
  name: string;
  value: number;
}) => {
  trackEvent("web_vital", {
    event_label: metric.id,
    metric_name: metric.name,
    metric_value: Math.round(
      metric.name === "CLS" ? metric.value * 1000 : metric.value,
    ),
  });
};
